import type { PointerEvent } from "react";

/** Hover handlers that only a mouse triggers: on a touch screen a hover change eats the first tap. `key` is "base" or a place's slug. */
export const mouseHover = (onHover: (key: string | null) => void, key: string) => ({
	onPointerEnter: (e: PointerEvent) => e.pointerType === "mouse" && onHover(key),
	onPointerLeave: (e: PointerEvent) => e.pointerType === "mouse" && onHover(null),
});
